import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends, assertThisInitialized as _assertThisInitialized } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ReactModal from 'react-modal';
import style from './ModalContainer.module.scss.js';
import { Regular } from '@piconetworks/pkg-box';
import ModalContext from './ModalContext.js';
import ModalTrigger from './ModalTrigger.js';

var _excluded = ["appElement", "centered", "children", "className", "scrollable", "size", "triggerComponent", "position", "overlayClass", "onAfterClose"];
var ModalContainer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ModalContainer, _Component);
  function ModalContainer(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.modalContext = {
      onClose: function onClose() {
        return _this.handleClose();
      }
    };
    _this.state = {
      isOpen: props.setOpen
    };
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = ModalContainer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.appElement) {
      ReactModal.setAppElement(this.props.appElement);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cleanupModal();
  };
  _proto.handleOpen = function handleOpen() {
    this.setState({
      isOpen: true
    });
  };
  _proto.handleClose = function handleClose() {
    this.setState({
      isOpen: false
    });
  };
  _proto.cleanupModal = function cleanupModal() {
    var element = document.body;
    element.classList.remove(style.modalOpen);
  };
  _proto.render = function render() {
    var _cx,
      _this2 = this;
    var _this$props = this.props;
      _this$props.appElement;
      var centered = _this$props.centered,
      children = _this$props.children,
      className = _this$props.className,
      scrollable = _this$props.scrollable,
      size = _this$props.size,
      triggerComponent = _this$props.triggerComponent,
      position = _this$props.position,
      overlayClass = _this$props.overlayClass,
      _onAfterClose = _this$props.onAfterClose,
      args = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (typeof window === undefined) {
      return null;
    }
    return /*#__PURE__*/React.createElement(ModalContext.Provider, {
      value: this.modalContext
    }, /*#__PURE__*/React.isValidElement(triggerComponent) && /*#__PURE__*/React.createElement(ModalTrigger, {
      onClick: this.handleOpen
    }, triggerComponent), /*#__PURE__*/React.createElement(ReactModal, _extends({
      isOpen: this.state.isOpen,
      bodyOpenClassName: cx(this.state.isOpen && style.modalOpen),
      onRequestClose: this.handleClose,
      className: cx(style.modalDialog, scrollable && style.modalDialogScrollable, size && style[size + "Modal"], centered && style.modalDialogCentered, position && style.modalPosition, position && style[position], className),
      overlayClassName: cx(style.modal, style.show, style.modalBackdrop, (_cx = {}, _cx[style.modalBackdropShow] = this.state.isOpen, _cx), overlayClass),
      onAfterClose: function onAfterClose() {
        _this2.cleanupModal();
        if (_onAfterClose) {
          _onAfterClose();
        }
      }
    }, args), /*#__PURE__*/React.createElement(Regular, {
      className: cx(style.modalContent, scrollable && style.modalContentScrollable)
    }, children)));
  };
  return ModalContainer;
}(Component);
ModalContainer.propTypes = {
  /**
   * App element should not be a parent of the modal, to prevent modal content from being hidden to screenreaders while it is open.
   */
  appElement: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Whether modal should be vertically centered
   */
  centered: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  overlayClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * How modal will be described to screenreaders
   */
  contentLabel: PropTypes.string.isRequired,
  /**
   * Boolean describing if the modal should initially set to be open
   */
  setOpen: PropTypes.bool.isRequired,
  /**
   * Function that will be run after the modal has closed.
   */
  onAfterClose: PropTypes.func,
  /**
   * Function that will be run after the modal has opened.
   */
  onAfterOpen: PropTypes.func,
  /**
   * Function that will be called to get the parent element
   * that the modal will be attached to.
   */
  parentSelector: PropTypes.func,
  scrollable: PropTypes.bool,
  shouldCloseOnEsc: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'default', 'lg', 'xl']),
  position: PropTypes.oneOf(['left', 'right']),
  /**
   * Boolean indicating if the overlay should close the modal
   */
  shouldCloseOnOverlayClick: PropTypes.bool,
  triggerComponent: PropTypes.any
};
ModalContainer.defaultProps = {
  // appElement: document.getElementById('root'),
  closeOnDocumentClick: true,
  closeOnEscape: true,
  scrollable: false,
  setOpen: false,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  size: 'default'
};

export { ModalContainer as default };
//# sourceMappingURL=ModalContainer.js.map
